'use strict';

import $ from 'jquery';
import storage from './storage';
import tyreselector from './tyreselector-4';
import filterBar from './filter-bar';
import 'select2';

let tyreselectorModel = {

  form: $('form[name="modelSearchForm"]'),
  drModes: ['years', 'models', 'vehicles', 'tyres'], // note: "manufacurers" is _not_ on this list. It has it's own functions.
  unwantedParameters: ['tyreSize', 'mobileTyreSize'], // these form element names should not be added to ajax requests or cache keys.
  missingModelData: false,
  get selects() { return this.form.find('select'); },
  get submitBtn() { return $(this.form).find('button[type="submit"]'); },
  get resultsContainer() { return $(this.form).find('.modelSizes:first'); }, // this also has the title element
  get clonedResultsContainer() { return $('.filter-bar .sizes.model:first'); },
  get resultsEl() { return $(this.form).find('.modelSizes:first').find('.results'); },
  get errorEl() { return $(this.form).find('.errorMessage:first'); },
  get parentEl (){ return $(this.form).closest('.ts-v4'); },
  dataUrl: '/stage-ajax/driveRight',
  searchText: window.tsSettings ? window.tsSettings.searchText : '',
  searchIcon: window.tsSettings ? window.tsSettings.searchIcon : null,

  initValues: {
    countryId: window.driveRightCountryCode,
    countryCode: window.driveRightLangCode,
    selectValues: [],
    selectKeys: []
  },

  minimumResultsForSearch: function ($select) {
    return 3;
  },

  populateForm: function () {
    var self = this;
    var x, j;

    // check what values have been set
    self.initValues.selectValues = [];
    self.initValues.selectKeys = [];

    if (window.cookieObj && window.cookieObj.manufacturer && window.cookieObj.manufacturer.value) { self.initValues.selectValues.push(window.cookieObj.manufacturer.value); self.initValues.selectKeys.push('manufacturer'); }
    if (window.cookieObj && window.cookieObj.year && window.cookieObj.year.value) { self.initValues.selectValues.push(window.cookieObj.year.value); self.initValues.selectKeys.push('year'); }
    if (window.cookieObj && window.cookieObj.model && window.cookieObj.model.value) { self.initValues.selectValues.push(window.cookieObj.model.value); self.initValues.selectKeys.push('model'); }
    if (window.cookieObj && window.cookieObj.vehicle && window.cookieObj.vehicle.value) { self.initValues.selectValues.push(window.cookieObj.vehicle.value); self.initValues.selectKeys.push('vehicle'); }

    // if values were found, start populating selects and results
    for (x = 0; x < self.initValues.selectValues.length; x++) {

      // first select ('manufacturer') gets it's values straight from HTML, so we only have to select correct value for it here.
      // other selects are dynamically updated and they get their "selected" values during population
      if (x === 0 && window.cookieObj && window.cookieObj.manufacturer && window.cookieObj.manufacturer.value) {
        var manufVal = window.cookieObj.manufacturer.value;

        $(self.selects).eq(0).find('option[value="' + manufVal + '"]:first').prop('selected', true);

        // refresh select2
        var $select = $(self.selects).eq(0);
        $select.eq(0).select2({
          minimumResultsForSearch: self.minimumResultsForSearch($(self.selects).eq(0)),
          language: {
            noResults: function() {
              return $select.data('no-results') || 'No results found';
            }
          }
        });
      }

      var populateOnly = true; // do not disable selects during population and do not modify cookie data.

      // selects are populated by using settings objects.
      var initObj = {
        'stage-language': window.tsSettings.selectedLang,
        countryId: self.initValues.countryId,
        countryCode: self.initValues.countryCode,
        tyreSelectorVersion: window.tsSettings.tyreSelectorVersion,
        mode: self.drModes[x]
      };

      for (j = 0; j <= x; j++) {
        initObj[self.initValues.selectKeys[j]] = self.initValues.selectValues[j];
      }
      // settings done, now populate selects
      self.getDataAndPopulate(x, initObj, populateOnly);
    }

  }, // populateForm

  selectChange: function (curSelect) {
    var self = this;
    var key = $(curSelect).attr('name'),
      value = $(curSelect).val(),
      text = $(curSelect).find('option[value="' + value + '"]:first').text(),
      index = parseInt($(curSelect).attr('data-index')),
      paramObj = {
        'stage-language': window.tsSettings.selectedLang,
        countryId: window.driveRightCountryCode,
        /* NOTE: in ajax request 'countryCode' actually means language */
        countryCode: window.driveRightLangCode,
        tyreSelectorVersion: window.tsSettings.tyreSelectorVersion
      };

    // US/CA may use new parameter "region"
    if (self.initValues.region) paramObj.region = self.initValues.region;

    // override initial country value if user has changed manufacturer list to show all.
    if (document.cookie.indexOf('driveRightCountryCode=ALL') !== -1) {
      paramObj.countryId = 'ALL';
    }

    if (!value) {
      if (index === 0) {
        // disable reset btn;
        self.resetBtn(false);
      }

      if (window.cookieObj && window.cookieObj[key]) delete window.cookieObj[key];
      self.checkSubmitState();

      if (window.cookieObj.tsViewNavItem && window.cookieObj.tsViewNavItem === '#filterModels') {
        // Change stored values only be done if we're actually dealing with 'Models' form.
        // This selectChange() was triggered when form was reset and size form's values got overwritten.
        window.cookieObj.width = undefined;
        window.cookieObj.height = undefined;
        window.cookieObj.rim = undefined;

        window.setTyreCookie();
      }

      // disable next selects
      $(self.selects).each(function () {
        var thisIndex = parseInt($(this).attr('data-index'));
        if (thisIndex > index) {
          self.disableSelect($(this));
        }
      });

      // last dropdown, no value... repopulate form
      if (index === 3) {
        self.populateForm();
      }

    }
    // value set, get data
    else {
      // store value to cookie instantly;
      window.cookieObj[key] = {
        value: value,
        text: text
      };

      window.setTyreCookie();
      // enable reset btn;
      self.resetBtn(true);
      // set ajax parameters
      paramObj.mode = self.drModes[index];
      // add parameters by current form values.
      $.each($(self.form).serializeArray(), function (_, kv) {
        // only add parameters that are not yet defined and not found in the list of unwanted parameters.
        if (typeof (paramObj[kv.name]) === 'undefined' && self.unwantedParameters.indexOf(kv.name) === -1) {
          paramObj[kv.name] = kv.value;
        }
      });

      self.getDataAndPopulate(index, paramObj);

    } // else
  }, // selectChange

  getDataAndPopulate: function (index, paramObj, populateOnly) {

    var self = this;

    // by default, next select should be disabled. Only if we're populating selects after page refresh shoud they remain active
    if (typeof populateOnly === 'undefined') populateOnly = false;

    // ----------------------------------------------------------------------------------------------------------------
    // if it's the MODEL select, populate 'vehicles' select and then get ALL vehicles' tyres
    // ----------------------------------------------------------------------------------------------------------------
    if (index === 2) {
      // create new param object with different 'mode' setting to get results for all vehicles
      var resultsParamObj = $.extend(true, {}, paramObj);
      // modify params for tyre query
      resultsParamObj.mode = 'tyres';

      // populate 'vehicles' dropdown
      doNextSelect(paramObj);

      //doResults(resultsParamObj);
    }
    // --------------------------------------------
    // if it's the last select POPULATE RESULTS
    // --------------------------------------------
    else if (index === 3) {
      doResults(paramObj);
    }
    // --------------------------------------------
    // enable + populate NEXT SELECT
    // --------------------------------------------
    else {
      doNextSelect(paramObj);
    } // else

    // ---------------------
    // do next select
    // ---------------------

    function doNextSelect(paramObj, resultsParamObj) {
      var nextSelect = $(self.selects).eq(index + 1);

      if (!populateOnly) {
        self.populateResults(); // without data this hides results;
      } // !populateOnly

      // disable all following selects, clear their cookie values
      $(self.selects).each(function (ei) {
        // if we're populating the first select, check it's value and enable/disable Clear-button accordingly.
        if ($(this).attr('id') === 'manufacturer' && $(this).val() !== '') {
          self.resetBtn(true);
        }
        else if ($(this).attr('id') === 'manufacturer' && $(this).val() === '') {
          self.resetBtn(false);
          self.resetForm();
        }

        if (parseInt($(this).attr('data-index')) > index) {
          self.disableSelect($(this));
          if (!populateOnly) {
            var key = $(this).attr('name');
            // delete previous choises from paramObj.
            delete paramObj[key];
            // delete previous choises from cookie
            delete window.cookieObj[key];

            window.setTyreCookie();
          }
        }
      });

      // check sessionstorage for pre-loaded data, if it's not prevented by request.
      var data = document.location.href.indexOf('flushCache') !== -1 ? false : tyreselector.getSessionData(paramObj);
      if (data) {
        self.populateSelect(nextSelect, data);
        self.checkSubmitState();
        if (resultsParamObj) {
          doResults(resultsParamObj);
        }
      }
      // if data was not found in sessionstorage, then get it with ajax
      else {
        // show throbber on next select
        self.loadingSelect(nextSelect, true);
        // add lang parameter into paramObj
        paramObj.lang = $('html').attr('lang');

        // load data
        $.ajax({
          url: self.dataUrl,
          cache: false,
          data: paramObj,
          success: function (data) {
            if (data === null) {
              self.populateSelect(nextSelect); // without data this just clears next select
            } else {
              // success with data
              if (index === 0) {
                // we're dealing with years. We want them descending. sort it out!
                var byYear = data.data;
                byYear.sort(function (a, b) {
                  if (a.text < b.text) { return 1; }
                  else { return -1; }
                });
              }
              // if we have sessionStorage support, let's store results there
              if (storage.session) {
                tyreselector.storeSessionData(data, paramObj);
              }
              // choose if select should be opened or not
              // do not open if we're only populating or next select is "vehicle";
              var psCallBack = populateOnly || $(nextSelect).attr('name') === 'vehicle' ? function () { } : function () { nextSelect.select2('open'); };
              self.populateSelect(nextSelect, data, psCallBack);
              self.checkSubmitState();

              if (resultsParamObj) {
                doResults(resultsParamObj);
              }
            }
          },
          error: function () {
            self.populateSelect(nextSelect); // without data this just clears next select
          } // error
        }); // ajax
      } // !data
    } // doNextSelect();

    // ------------------
    // do results
    // ------------------

    function doResults(paramObj) {

      var sizesForVehicle;
      var selectEl = $(self.selects).eq(index);
      self.loadingSelect(selectEl, true);

      function vehicleChosen(paramObj) {
        if (paramObj && paramObj.vehicle) return true;
        if (paramObj && !paramObj.vehicle) return false;
        else return (window.cookieObj && window.cookieObj.vehicle ? true : false);
      }

      // hide visible results if any
      $(self.resultsContainer).show('fast');
      $(self.submitBtn).prop('disabled', true);
      $(self.resultsEl).slideUp('fast');
      $('.modelSizes h2:first span.text span.extra').remove();

      // check sessionstorage for pre-loaded data, if it's not prevented by request.
      var data = document.location.href.indexOf('flushCache') !== -1 ? false : tyreselector.getSessionData(paramObj);

      if (data) {
        // do not parse model's tyresizes if user has chosen a vehicle
        if (!vehicleChosen(paramObj) && vehicleChosen()) {
          console.warn('skipping model\'s sizes');
        }
        else {
          self.populateResults(data, null, paramObj);
          self.loadingSelect(selectEl, false);
        }
      }
      // if data was not found in sessionstorage, then get it with ajax
      else {
        $(self.resultsContainer).toggleClass('loading', true);
        // add lang parameter into paramObj
        paramObj.lang = $('html').attr('lang');

        $.ajax({
          url: self.dataUrl,
          cache: false,
          data: paramObj,
          error: function (xhr, ajaxOptions, thrownError) {
            // remove loading throbber
            $(self.resultsContainer).toggleClass('loading', false);
            $(self.parentEl).toggleClass('loading',false);
            self.loadingSelect(selectEl, false);

            // get localized error msgs if any
            var errorMsg;

            // If model request takes too long (over 20 sec), a Gateway Timeout (504) occours.
            // This seems to be common if model has not been previously requested and it has many engine options.
            // Each engine (vehicle) must be requested from DriveRight, and it takes plenty of time to finish with the results.
            // We do not want to scare users away with an error message, so let's just instruct them to continue by choosing an engine.
            // NOTE: only do this, if user has not yet chosen a vehicle.
            if (!vehicleChosen() && xhr && xhr.status && xhr.status === 504) {
              // try to get localized message...
              errorMsg = window.loc && window.loc.tyreselector_please_choose_engine ? window.loc.tyreselector_please_choose_engine : 'Please choose engine.';
            } // model search
            // more generic errors
            else {
              errorMsg = thrownError ? 'Error: ' + thrownError + '. ' : 'Error. ';
              errorMsg += window.loc && window.loc.tyreselector_try_again_later ? window.loc.tyreselector_try_again_later : ' Please try again later. Sorry for the inconvenience.';
            }

            sizesForVehicle = errorMsg ? '<p>' + errorMsg + '</p>' : '';
            self.populateResults(sizesForVehicle, null, paramObj);

          },
          success: function (data) {

            sizesForVehicle = data;

            // NO RESULTS AT ALL
            // replace result object with htmlsting containing text 'tyre sizes not available'
            if (sizesForVehicle === null || (typeof (sizesForVehicle) === 'object' && sizesForVehicle.data && sizesForVehicle.data.length === 0)) {
              // search document for pre-defined error html
              if (typeof window.noResults === 'function') sizesForVehicle = window.noResults();
              else sizesForVehicle = '<p>' + (window.loc && window.loc.tyreselector_no_size_data ? window.loc.tyreselector_no_size_data : 'No tyre size data available for this vehicle.') + '</p>';
            }

            // REMOVE INVALID RESULTS
            // Driveright can actually send this kind of result: "145/R10" (from: Austin/1978/Mini(1958-1993)/Cooper S(55kW))
            // We do not need such nonsense, so loop thru results and check if any of width/height/rim/loadIndex/speedRating info is missing, and remove that result.
            if (typeof (sizesForVehicle) === 'object' && typeof (sizesForVehicle.data) !== 'undefined' && sizesForVehicle.data.length) {
              var resArr = sizesForVehicle.data;
              var i,
                j;

              for (i = 0; i < resArr.length; i++) {
                var txtCount = typeof (resArr[i].text) !== 'undefined' ? resArr[i].text.length : 0;

                // check that we have correct number of values in array
                if (paramObj.mode === 'tyres' && txtCount !== 5) {
                  resArr.splice(i, 1);
                }
                else {
                  // loop thru texts, check that they have values.
                  for (j = 0; j < txtCount; j++) {
                    if (!resArr[i] || !resArr[i].text || !resArr[i].text[j]) {
                      // value is missing, ditch this result!
                      console.warn('ditching invalid ajax result. some of the required texts are missing:', resArr[i]);
                      resArr.splice(i, 1);
                    }
                  }
                }
              } // end loop

              // No valid results left after removing invalid results:
              // replace result object with htmlsting containing text 'tyre sizes not available'
              if (!resArr.length) {
                // search document for pre-defined error html
                if (typeof window.noResults === 'function') sizesForVehicle = window.noResults();
                else sizesForVehicle = '<p>No tyre size data available for this vehicle.</p>';
              }
              else {
                // store valid results
                sizesForVehicle.data = resArr;
              }
            }

            // if we have sessionStorage support and valid data, let's store results
            if (storage.session && typeof sizesForVehicle !== 'string') {
              tyreselector.storeSessionData(sizesForVehicle, paramObj);
            }

            // If current request was for all model's tyresizes, and user has after that chosen a specific vehicle, then do not parse results.
            // This check is done to prevent a situation where model request populates results AFTER user has chosen a vechile: user gets wrong results.

            if (!vehicleChosen(paramObj) && vehicleChosen()) {
              void (0); // do nuthin
            }
            else {
              // new on tyreselector v3
              // populate results, sizesforVechicle contains data of default sizes, so no need for separate ajax query
              self.populateResults(sizesForVehicle, null, paramObj);
            }

            self.loadingSelect(selectEl, false);

          }
        }); // ajax
      }
    } // doResults();
  }, // getDataAndPopulate()

  populateSelect: function (selectEl, data, callback) {

    /*
    Check if selectEl contains optgroups. This is possible at least in 'manufacturers' selectEl on some sales regions.
    if no <optgroup> elements are not found, then targetEl is the selectEl, otherwise it's the 2nd optgroup.
    */
    var self = this;
    var optGroups = $(selectEl).find('optgroup'),
      targetEl = optGroups.length > 1 ? $(optGroups).eq(1) : $(selectEl);

    if (!data) {
      // remove old options if any
      $(selectEl).find('option').not(':first').remove();
      self.loadingSelect(selectEl, false);
      // enable select
      self.enableSelect(selectEl, true);
      // refresh select2 values
      var $select = $(selectEl);
      $select.select2({
        minimumResultsForSearch: self.minimumResultsForSearch($(selectEl)),
        language: {
          noResults: function() {
            return $select.data('no-results') || 'No results found';
          }
        }
      });
    }
    else {

      var htmlStr = '';
      if (typeof data === 'string') {
        try { data = JSON.parse(data); }
        catch (e) { return false; }
      }
      $(data.data).each(function (i) {
        var selectedStr = '';

        if (typeof (window.cookieObj) !== 'undefined') {
          var key = $(selectEl).attr('name');
          // make it selected if value matches with value in cookie.
          if (window.cookieObj[key] && window.cookieObj[key].value && window.cookieObj[key].value === this.value) {
            selectedStr = 'selected="selected" ';
          }
        }
        // "text" might be just a string or an array of info.
        // for example: on "engine" dropdown "text" is an array. It also contains info about vehicle type.
        // if such data exists, write it to <option> element as an extra attribute
        var textType = typeof (this.text),
          textStr = textType !== 'object' && textType !== 'undefined' && this.text !== null ? this.text : false,
          extraData = '';
        if (!textStr && textType !== 'undefined' && this.text !== null && this.text.length) {
          textStr = this.text[0];
          extraData = this.text[1];
        }
        if (extraData !== '') extraData = 'data-extra="' + extraData + '" ';
        htmlStr += '<option ' + extraData + selectedStr + 'value="' + this.value + '">' + textStr + '</option>';
      });
      // remove old options if any
      if (targetEl.prop('tagName') === 'SELECT') {
        $(targetEl).find('option').not(':first').remove();
      }
      else {
        $(targetEl).find('option').remove();
      }
      // insert new options
      $(targetEl).append(htmlStr);
      // hide throbber
      self.loadingSelect(selectEl, false);
      // enable next select
      self.enableSelect(selectEl, true);

      // it's possible to have 2 selected values on "manufacturers", since there may be common manufacturers first.
      // in such case remove "selected" attribute from the 2nd selected option. Only the first matching option should be selected (the one in common manufacturers)
      $(selectEl).find(':selected').each(function (optIndex) {
        if (optIndex !== 0) $(this).prop('selected', false);
      });

      // NOTE:
      // ts3 needs to have constructionType value in "models" selection
      // if we are populating engines, add constructionType info to select and window.cookieObj

      var selectName = $(selectEl).attr('name');
      if (selectName && selectName === 'vehicle') {
        var cTypes = {};
        // loop vehicles, store count of constructionType occourences
        $(selectEl).find('option[data-extra]').each(function () {
          var cType = $(this).attr('data-extra');
          if (!cTypes[cType]) cTypes[cType] = 1;
          else cTypes[cType]++;
        });

        // What was the most common constructionType?
        var mostCommonCtype,
          mostCommonCtypeCount;
        for (var prop in cTypes) {
          if (!Object.prototype.hasOwnProperty.call(cTypes, prop)) continue;
          if (!mostCommonCtypeCount || cTypes[prop] > mostCommonCtypeCount) {
            mostCommonCtype = prop;
            mostCommonCtypeCount = cTypes[prop];
          }
        }

        // if we know the most common constructionType, store info
        if (window.cookieObj && window.cookieObj.model) {
          window.cookieObj.model.constuctionType = mostCommonCtype;

          if (window.vehicleTypes) {
            $(window.vehicleTypes).each(function () {
              if ($(this).prop('k') === mostCommonCtype) {
                window.cookieObj['model']['ntProdGroupPid'] = $(this).prop('v');
              }
            });
          }

          window.setTyreCookie();
          self.checkSubmitState();
        }
      }

      // refresh select2 if it's in use
      var $select2 = $(selectEl);
      $select2.select2({
        minimumResultsForSearch: self.minimumResultsForSearch($(selectEl)),
        language: {
          noResults: function() {
            return $select2.data('no-results') || 'No results found';
          }
        }
      });
    }

    if (typeof (callback) === 'function') {
      callback();
    }
  }, // populateSelect()

  populateResults: function (data, defaultSizeData, paramObj) {

    // populate results of model search
    var self = this;
    self.missingModelData = false;
    $(self.errorEl).contents().remove();
    $(self.errorEl).hide();

    function activateSize(input) {
      // things to do when activating a size
      // modify parent element's class
      $(input).attr('checked', 'checked').parents('.result').toggleClass('active', true);

      // store selection to cookie, if it has none
      if (window.cookieObj) { /* && (!window.cookieObj.width || !window.cookieObj.height || !window.cookieObj.rim ) */

        var value = input.val(),
          splitted = value ? value.split(',') : false;

        if (value && window.cookieObj.tsViewNavItem === '#filterModels') {

          /* remove license search results if any */
          if (window.cookieObj.license) delete window.cookieObj.license;

          window.cookieObj.width = ~~splitted[0];
          window.cookieObj.height = ~~splitted[1];
          window.cookieObj.rim = ~~splitted[2];

          window.setTyreCookie();
          if (typeof tyreselector.parseResults === 'function') tyreselector.parseResults('model.populateResults()');

          // on tyres page: change submit button's text and action
          input.parents('form').find('[type="submit"]').each(function () {
            tyreselector.modifyTsSubmitButton($(this), true);
          });

        }
      }
    } // activateSize

    // first check what kind of result should be shown.
    // hide results if no data
    if (!data) {
      if ($(self.resultsContainer).is(':visible')) {
        $(self.resultsContainer).hide();
        self.checkSubmitState();
      }
    }
    // driveright data is missing, show string containing message
    else if (typeof (data) === 'string' || !data.data) {
      var errorMessage = '';
      if (typeof (data) === 'string') {
        errorMessage = data;
      } else {
        errorMessage = (window.loc && window.loc.tyreselector_no_size_data ? window.loc.tyreselector_no_size_data : 'No tyre size data available for this vehicle.');
      }
      $(self.errorEl).contents().remove();
      $(self.errorEl).append(errorMessage).show();
      self.missingModelData = true;

      $(self.resultsEl).contents().remove();
      self.checkSubmitState();
      $(self.resultsEl).append(errorMessage);
      if ($(self.resultsEl).not(':visible')) {
        $(self.resultsEl).show();
      }
      $(self.resultsContainer).toggleClass('loading', false);
    }
    else {
      if (typeof tyreselector.resetTyreSelectorForms === 'function') tyreselector.resetTyreSelectorForms(['licenseSearchForm', 'sizeSearchForm']);

      $(self.resultsEl).contents().remove();
      self.checkSubmitState();

      var resultArray = data.data,
        atLeastOneIsAvailable = false,
        defaultIsAvailable = false,
        firstResult = false,
        minLI, // lowest Load Index value of DR resultset
        minSP, // lowest Speed Range value of DR resultset
        curLI,
        curSP,
        curSPindex,
        minSPindex,
        LIs = [],
        SPs = [],
        i;

      // set loadIndex & speedRating settings to lowest found in DR resultset
      for (i = 0; i < resultArray.length; i++) {
        curLI = parseInt(resultArray[i].text[3]);
        curSP = resultArray[i].text[4];
        curSPindex = window.speedRatings.indexOf(curSP);

        // LOAD INDEX
        LIs.push(curLI);
        if (typeof (minLI) === 'undefined' || minLI > curLI) minLI = curLI;

        // SPEED RATING
        SPs.push(curSP);
        // set initial value if result was found in window.speedRatings
        if (curSPindex !== -1 && typeof (minSP) === 'undefined') {
          minSP = curSP;
          minSPindex = curSPindex;
        }
        // compare against current value
        else if (curSPindex !== -1 && curSPindex < minSPindex) {
          minSP = curSP;
          minSPindex = curSPindex;
        }
      } // end dr results loop

      // Sort resultArray by sort by RIM
      Array.prototype.sortByRim = function (p) {
        return this.sort(function (a, b) {
          return (a[p][2] > b[p][2]) ? 1 : (a[p][2] < b[p][2]) ? -1 : 0;
        });
      };
      resultArray.sortByRim('text');

      /* These days DriveRight returns also M+S tyres as separate sizes.
      sizeLabels array is used to strip duplicate sizes from results */
      var sizeLabels = [],
        defaultSizeLabels = [];

      // default size info may not be in defaultSizeData. It may be a part of resultArray.
      // if so, do initial result loop to find all sizes that are manufacturer defaults.
      if (!defaultSizeData) {
        for (i = 0; i < resultArray.length; i++) {
          (function () {
            var width = parseInt(resultArray[i].text[0]),
              height = parseInt(resultArray[i].text[1]),
              rim = parseInt(resultArray[i].text[2]),
              defaultSizeDataAppended = typeof resultArray[i].default !== 'undefined', // default size info _may_ be a part of size data
              sizeLabel = width + '/' + height + 'R' + rim;
            if (defaultSizeDataAppended && resultArray[i].default === true) defaultSizeLabels.push(sizeLabel);
          })();
        }
      }

      // Loop result array
      for (i = 0; i < resultArray.length; i++) {
        var newResult = $(window.newResult()),
          width = parseInt(resultArray[i].text[0]),
          height = parseInt(resultArray[i].text[1]),
          rim = parseInt(resultArray[i].text[2]),
          defaultSizeDataAppended = typeof resultArray[i].default !== 'undefined', // default size info _may_ be a part of size data
          sizeLabel = width + '/' + height + 'R' + rim,
          value = width + ',' + height + ',' + rim + ',' + minLI + ',' + minSP,
          inputEl = newResult.find('input'),
          widthEl = newResult.find('.width'),
          heightEl = newResult.find('.height'),
          rimEl = newResult.find('.rim'),
          availableEl = newResult.find('.availabilityTxt'),
          defaultEl = newResult.find('.defaultTxt'),
          defaultSizeCheck = function () {
            if (defaultSizeDataAppended) {
              if (defaultSizeLabels.length && defaultSizeLabels.indexOf(sizeLabel) !== -1) return true;
              else return resultArray[i].default;
            }
            else if (defaultSizeData) {
              var str = defaultSizeData.data[0].text,
                w = undefined,
                h = undefined,
                r = undefined;
              if (!str) { console.error('defaultSizeData is invalid:'); console.warn(defaultSizeData); console.warn(JSON.stringify(defaultSizeData)); return false; }
              // try to extract data from string
              if (str.indexOf('/') !== -1 && str.indexOf('R') !== -1) {
                var split1 = str.split('/'),
                  split2 = split1[1].toString().split('R');
                w = parseInt(split1[0]);
                h = parseInt(split2[0]);
                r = parseInt(split2[1]);
                // finally if values match, it's factory default, jei!
                if (width === w && height === h && rim === r) return true;
              }
            }
            return false;
          },
          defaultSize = defaultSizeCheck(),
          available = false,
          keys = ['width', 'height', 'rim', 'li', 'sp'];

        // Store first size from result list to a varilable. This is needed for redirection in case there are no available sizes in results.
        if (!firstResult && width && height && rim) firstResult = [width, height, rim];

        // Check availability by comparing to sizeData
        for (var ii = 0; ii < window.sizeData.length; ii++) {
          if (window.sizeData[ii][keys.indexOf('width')] === width && window.sizeData[ii][keys.indexOf('height')] === height && window.sizeData[ii][keys.indexOf('rim')] === rim) {
            // size matches, do additional filtering:

            if (minLI && minSPindex && minSP) {

              // Is this tyre's Load Index value smaller than the lowest Load Index value in DriveRight's vehicle results?
              // If so, then this tyre is not allowed to the current vehicle. Do nothing.
              if (minLI > window.sizeData[ii].li) {
                console.warn('load index too low: ', window.sizeData[ii]);
              }
              // Is this tyre's Speed Rating value lower than the lowest Speed Rating value in DriveRight's vehicle results?
              // If so, then this tyre is not allowed to the current vehicle.
              else if (1 === 2 && window.season !== 'winter' && minSPindex > window.speedRatings.indexOf(window.sizeData[ii].sp)) {
                console.warn('speed rating too low: ', minSPindex, window.sizeData[ii]);
              }
              // otherwise make it available!
              else {
                available = true;
                atLeastOneIsAvailable = true;
                if (defaultSize) defaultIsAvailable = true;
                break;
              }
            }
          } // sizeMatch
        } // end availability loop

        // set values
        $(inputEl).val(value);
        $(widthEl).text(width);
        $(heightEl).text(height);
        $(rimEl).text(rim);

        if (!defaultSize) defaultEl.remove();
        else $(inputEl).attr('data-manufacturer-default', 'true');

        if (!available) {
          $(defaultEl).remove(); // no need to show it if the tyre is not available.
          $(newResult).toggleClass('notAvailable', true);
          $(inputEl).prop('disabled', true);
        }
        else {
          // it is available, so must remove text 'not available'
          $(availableEl).remove();
        }

        $(newResult).on('click', function (e) {
          if (!$(this).hasClass('notAvailable')) {
            $('.result').toggleClass('active', false);
            $(this).toggleClass('active', true);
          }
        });

        // finally, check if matching label has been appended already. Without this check M+S tyres may create duplicate results.
        if (sizeLabels.indexOf(sizeLabel) === -1) {
          sizeLabels.push(sizeLabel);
          $(self.resultsEl).append(newResult);
        }

      } // end result loop

      // set active size
      if (atLeastOneIsAvailable || defaultIsAvailable) {
        // get active radio inputs
        var inputs = $(self.form).find('input[type="radio"]').not(':disabled');

        // choose the selected size.
        var selectedSizeStr = false,
          matchedInput = false,
          selectedSizeIsFromQueryString;

        const querySize = tyreselector.getUrlParameter('s');

        // if we are on tyres page and in 'by-tyre-size' view, then search for a match in querystring's "s" (size) parameter value
        if (querySize && tyreselector.tsEl.hasClass('by-tyre-size') && tyreselector.tsEl.hasClass('use-filter-groups')) {
          const separators = ['-', '+', '%20', ' '];
          let separator;

          // choose first found separator (in querystring) from separators.
          for (let i = 0; i < separators.length; i++) {
            if (querySize.indexOf(separators[i]) > -1) {
              separator = separators[i];
              break;
            }
          }

          if (separator) {
            const values = querySize.split(separator),
              w = ~~values[0], // convert to integer with ~~
              h = ~~values[1], // convert to integer with ~~
              r = ~~values[2]; // convert to integer with ~~

            selectedSizeStr = w + ',' + h + ',' + r;
            selectedSizeIsFromQueryString = true;
          }

        }
        // if window.cookieObj contains info about selected size, and that size happens to be available, select that size.
        else {
          selectedSizeStr = (window.cookieObj.width && window.cookieObj.height && window.cookieObj.rim) ? window.cookieObj.width + ',' + window.cookieObj.height + ',' + window.cookieObj.rim : false;
        }

        // check if any of the input sizes match the selectedSizeStr
        if (selectedSizeStr) {
          $(inputs).each(function () {
            var splittedVal = $(this).val().split(','),
              parsedStr = splittedVal.length > 2 ? splittedVal[0] + ',' + splittedVal[1] + ',' + splittedVal[2] : '';
            if ($(this).val() === selectedSizeStr) matchedInput = $(this);
            else if (selectedSizeStr === parsedStr) matchedInput = $(this);
          });
        }

        // Choose what size to activate
        //
        // we have selectedSizeStr and a matching size
        if (selectedSizeStr && matchedInput) {
          activateSize(matchedInput);
        }

        // "by-tyre-size" view, scene 1:
        // 1) There is a size in querysting, but no matching input found AND user has clicked the submit button
        // In this case we must choose a size.
        else if (selectedSizeIsFromQueryString && tyreselector.formSubmitted && !matchedInput) {
          // else if manufacturers default size is available, choose it.
          if (defaultIsAvailable) {
            activateSize($(inputs).filter('[data-manufacturer-default="true"]:first'));
          }
          // at least, choose the first option
          else {
            activateSize($(inputs).eq(0));
          }
        }

        // "by-tyre-size" view, scene 2:
        // 2) there is no size matching querystring
        else if (selectedSizeIsFromQueryString) {
          // Do not select any size.
          // Now user must choose the size by clicking the size link or let tyreselector choose automatically by clicking submit button
        }

        // else if manufacturers default size is available, choose it.
        else if (defaultIsAvailable) {
          activateSize($(inputs).filter('[data-manufacturer-default="true"]:first'));
        }
        // at least, choose the first option
        else {
          activateSize($(inputs).eq(0));
        }
      } // atLeastOneIsAvailable || defaultIsAvailable
      //
      // new tyreselector v3.1
      // no sizes available, choose first size from driveright results even if it's not available
      else if (firstResult && firstResult.length === 3) {

        if (window.cookieObj.tsViewNavItem === '#filterModels') {

          /* remove license search results if any */
          if (window.cookieObj.license) delete window.cookieObj.license;

          window.cookieObj.width = ~~firstResult[0];
          window.cookieObj.height = ~~firstResult[1];
          window.cookieObj.rim = ~~firstResult[2];

          window.setTyreCookie();
          if (typeof tyreselector.parseResults === 'function') tyreselector.parseResults('model.populateResults() 1011');

        }

      } // choose first size whatever

      if ($(self.resultsEl).not(':visible')) {
        $(self.resultsEl).slideDown('fast', function () {
          self.checkSubmitState();
        });
      }

      $(self.resultsContainer).toggleClass('loading', false);


      if (atLeastOneIsAvailable) {
        $(self.resultsEl).find('input:checked').focus();
      }

      // update results and mobile dropdown in .filter-bar
      filterBar.updateFilterBar('modelSearchForm');


    } // we have data
  }, // populateResults

  checkSubmitState: function () {
    var self = this;
    if ($(self.form).attr('name') === 'modelSearchForm' && window.cookieObj && window.cookieObj.model && !self.missingModelData && window.cookieObj.vehicle) {
      $(self.submitBtn).prop('disabled', false);
    }
    else {
      $(self.submitBtn).prop('disabled', true);
    }
  },

  disableSelect: function (el, current) {

    if (!current) current = false;
    $(el).find('option').not(':first').remove();
    $(el).select2();
    $(el).prop('disabled', true);
    $(el).parents('label')
      .toggleClass('disabled', true)
      .toggleClass('active', false)
      .toggleClass('current', current);
    $(el).removeAttr('data-icon-set');

  }, // disableSelect

  enableSelect: function (el, current) {
    if (!current) current = false;
    $(el).prop('disabled', false);
    $(el).parents('label')
      .toggleClass('disabled', false)
      .toggleClass('active', true)
      .toggleClass('current', current);

  }, // enableSelect()

  loadingSelect: function (el, state) {
    if (!state) state = false;
    el.parents('label').toggleClass('loading', state);
  }, // loadingSelect()

  resetModelForm: function (resetCookieValues, removeResults) {
    var self = this;
    if (typeof resetCookieValues === 'undefined') resetCookieValues = false;
    self.resetForm(resetCookieValues, removeResults, 'model.resetModelForm()');
    return true;
  },

  resetForm: function (resetCookieValues, removeResults, caller) {
    var self = this;

    if (resetCookieValues) {
      delete window.cookieObj.manufacturer;
      delete window.cookieObj.model;
      delete window.cookieObj.vehicle;
      delete window.cookieObj.year;
      if (window.cookieObj.id) delete window.cookieObj.id;
      if (window.cookieObj.productInfo) delete window.cookieObj.productInfo;
      if (window.cookieObj.productName) delete window.cookieObj.productName;

      window.setTyreCookie(); // write window.cookieObj to storage
    }

    if (removeResults) {
      $(self.resultsContainer).hide();
      $(self.resultsEl).html('');
    }

    $(self.selects).each(function () {
      $(this).parents('label').toggleClass('disabled', true);
      $(this).val('').trigger('change').prop('disabled', true);
    });

    //console.log('resetForm resetBtn')
    //self.resetBtn(false); // hide

    // reset submit button's default action and text
    tyreselector.modifyTsSubmitButton($(self.submitBtn), false);

    self.populateResults(); // without data this hides any visible results in search area
    if (typeof tyreselector.parseResults === 'function') tyreselector.parseResults('model.resetForm()'); // update product list and tyreselector header
    return true;
  },

  resetBtn: function (show) {
    var self = this;
    var clearBtn = $(self.form).find('.clearBtn');
    // insert button if it's not there yet
    if (!clearBtn.length) {
      clearBtn = $('<a href="#" class="clearBtn button">' + window.loc.tyreselector_clear + '</a>');
    }

    clearBtn.on('click', function (e) {
      e.preventDefault();
      if (window.cookieObj) {
        window.cookieObj = {
          width: undefined,
          height: undefined,
          rim: undefined,
          tsViewNavItem: '#filterModels'
        };

        window.setTyreCookie();
        self.checkSubmitState();
        if (typeof tyreselector.parseResults === 'function') tyreselector.parseResults('model.resetBtn()');
      }
      if (typeof tyreselector.resetTyreSelectorForms === 'function') {
        tyreselector.resetTyreSelectorForms();
      }
      else {
        self.resetForm();
      }
      //self.getVehicleData();
    });
    $(self.submitBtn).after(clearBtn);

    // if we only want to toggle visibility, then pass this
    if (typeof show !== 'undefined') {
      if (show && $(clearBtn).not(':visible')) { $(clearBtn).slideDown('fast');/*.toggleClass('active',true);*/ /*.fadeIn('fast');*/ }
      else if ($(clearBtn).is(':visible')) { $(clearBtn).slideUp('fast');/*.toggleClass('active',false);*/ /*.fadeOut('fast');*/ }
    }
  }, // resetBtn();

  getVehicleData: function () {
    // this function checks cookie for what set of manufacturers (if any) user has requested.
    // If data is available in sessionStorage, it it used. If not, an ajax call is made.
    var self = this;
    var drCC = false,
      data = false,
      paramObj = {},
      selectEl = $(self.selects).eq(0),
      i;

    // check if cookie contains info about what results to get
    if (document.cookie.indexOf('driveRightCountryCode') !== -1) {
      var cookieData = document.cookie.split('; ');
      for (i = 0; i < cookieData.length; i++) {
        if (cookieData[i].indexOf('driveRightCountryCode') === 0) {
          drCC = cookieData[i].toString().split('=')[1];
        }
      }
    }

    if (!drCC) {
      // if there was no data in cookie, then choose what manufacturer data to get : "country specific" list or "all manufacturers"
      // is current country available in driveRight countries?
      if (typeof (window.drCountries) !== 'undefined' && typeof (window.selectedCountry) !== 'undefined' && window.drCountries.indexOf(window.selectedCountry) !== -1) {
        drCC = window.selectedCountry;
      }
      else {
        drCC = 'ALL';
      }
    } // !drCC

    // now we have a valid code to load with
    // check if data is in sessionStorage
    paramObj = {
      'stage-language': window.tsSettings.selectedLang,
      countryId: drCC,
      /* NOTE: in ajax request "countryCode" means language */
      countryCode: typeof (window.driveRightLangCode) !== 'undefined' ? window.driveRightLangCode : 'en',
      mode: 'manufacturers',
      tyreSelectorVersion: window.tsSettings.tyreSelectorVersion
    };

    // check sessionstorage for pre-loaded data, if cache use is not prevented by request.
    data = document.location.href.indexOf('flushCache') !== -1 ? false : tyreselector.getSessionData(paramObj);
    if (data) {
      self.populateSelect(selectEl, data);
    }
    // if data was not found in sessionstorage, then get it with ajax
    else {
      // show throbber on next select
      self.loadingSelect(selectEl, true);
      // add lang parameter into paramObj
      paramObj.lang = $('html').attr('lang');

      // load data
      $.ajax({
        url: self.dataUrl,
        cache: false,
        data: paramObj,
        success: function (data) {
          // remove data from object for alphabetical sorting
          var resultArr = data.data,
            storeObj = {};

          // manufacturers need to be sorted alphabetically. sort'em!
          resultArr.sort(function (a, b) {
            if (!a || !b || typeof (a.text) === 'undefined' || typeof (b.text) === 'undefined') {
              console.warn('sorting failed!', a, b, paramObj);
              return 0;
            }
            return a.text.localeCompare(b.text);
          });
          // remove dem pesky motorcyclez
          var len = resultArr.length;
          while (len--) {
            var itemKey = parseInt(resultArr[len].value);
            if (!isNaN(itemKey) && (itemKey > 4047 && itemKey < 4088)) {
              resultArr.splice(len, 1);
            }
          }
          storeObj.data = resultArr;

          // store to browser sessionData
          tyreselector.storeSessionData(storeObj, paramObj);

          // populate select + trigger change
          self.populateSelect(selectEl, storeObj, function () {
            self.selectChange(selectEl);
          });

        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error(jqXHR);
          console.error('Error ' + jqXHR.status + ': ' + errorThrown + '\nFailed to get manufacturer data. Resetting.');
          document.cookie = 'driveRightCountryCode=ALL';
          window.driveRightCountryCode = 'ALL';
          self.resetForm();
          self.getVehicleData();
        }


      }); // ajax
    } // !data

  }, // getNewVehicleData

  refreshVehicleData: function () {
    this.getVehicleData();
  },

  init: function () {
    console.log('TS4 : tyreselectorModel.init()');

    var self = this;

    tyreselector.modelForm = self;

    $(self.selects).each(function (index) {
      var $select = $(this);
      var placeholder = $(this).find('option:first').text();
      $(this).attr('placeholder', placeholder).attr('data-index', index);

      $(this).select2({
        placeholder: placeholder,
        minimumResultsForSearch: self.minimumResultsForSearch($(this)),
        language: {
          noResults: function() {
            return $select.data('no-results') || 'No results found';
          }
        }
      });


      $(this).on('select2:open', function () {
        document.querySelector('input.select2-search__field').focus();
        if (!$(this).attr('data-icon-set')) {
          $('input.select2-search__field').prop('placeholder', self.searchText);
          if (self.searchIcon) {
            const iconHtml = document.createElement('span');
            iconHtml.innerHTML = self.searchIcon;
            document.querySelector('.select2-search--dropdown')?.insertBefore(iconHtml, document.querySelector('input.select2-search__field') || null);
          }
          $(this).attr('data-icon-set', true)
        }
      })

      // if selected country is listed in "drCountries" array, it means that driveRight has a separate manufacturers list for this country.
      // in this case we must add an extra link to toggle what manufacturers list is shown in the first <select> element.
      if (index === 0 && typeof (window.drCountries) !== 'undefined' && window.drCountries.indexOf(window.selectedCountry) !== -1) {
        $(this).on('select2:open', function () {
          var curMenu = $('.select2-drop-active:visible'),
            showAllEl = $(curMenu).find('.toggleManufacturers');

          if (!$(showAllEl).length) {
            var nowShowingAll = document.cookie.indexOf('driveRightCountryCode=ALL') !== -1 ? true : false;

            var extraMenuItem = $('<a class="toggleManufacturers" href="#">' +
              (nowShowingAll ? window.loc.tyreselector_show_common_manufacturers : window.loc.tyreselector_show_all_manufacturers) + '</a>');
            curMenu.append(extraMenuItem);

            // toggle manufacturer list
            $(extraMenuItem).on('click', function (e) {
              e.preventDefault();

              // modify link to show common manufacturers for this country
              // If no cookie value exists, then current list is country specific. Switch to show all.
              if (document.cookie.indexOf('driveRightCountryCode') === -1) { document.cookie = 'driveRightCountryCode=ALL'; }
              // if showing country specific list, switch to ALL
              else if (document.cookie.indexOf('driveRightCountryCode=' + window.driveRightCountryCode) !== -1) { document.cookie = 'driveRightCountryCode=ALL'; }
              // switch to country specific list
              else { document.cookie = 'driveRightCountryCode=' + window.driveRightCountryCode; }

              self.resetForm();
              self.getVehicleData();

            });
          }
        });
      }
      // open first unselected dropdown, but only if current view is "by model"
      if (index === self.initValues.selectValues.length) {
        var manufacturerSelected = false, // eslint-disable-line no-unused-vars
          td_obj = storage.local ? localStorage.getItem('tyreData') : null;

        if (td_obj) {
          try {
            td_obj = JSON.parse(td_obj);
            if (td_obj.manufacturer) manufacturerSelected = true;
          }
          catch (e) {
            manufacturerSelected = false;
          }
        }

        // this means that results must be hidden (since something still is unselected)
        self.populateResults(); // without data this hides results
      }
      // disable following selects
      else if (index > self.initValues.selectValues.length) {
        self.disableSelect($(this));
      }
    })
      .on('change', function (e) {
        self.selectChange($(this));
      });

    // radio button changes
    $(document).on('change', 'form[name="modelSearchForm"] input[type="radio"][name="tyreSize"]', function (e) {

      var value = $(this).val();
      // store changed value right away for product filtering
      if (value) {
        var splitted = value.split(',');
        if (splitted.length > 2) {
          window.cookieObj.width = ~~splitted[0];
          window.cookieObj.height = ~~splitted[1];
          window.cookieObj.rim = ~~splitted[2];

          window.setTyreCookie();
        }
      }

      if (typeof tyreselector.parseResults === 'function') tyreselector.parseResults('model.sizeChange() (radiobutton change)');

    });

    self.populateForm();
    self.checkSubmitState();

  }, // init

};

export default tyreselectorModel;
